import Config from '../../config';
import {
  handleErrors,
  parseAsJson,
} from '../../utils/requestHelpers';
import fetch from '../../utils/fetchService';

export const fetchCurrencyConversionRates = async periodName => await fetch(
  Config.endpoints.FETCH_CURRENCY_CONVERSION_RATES
    .replace(/:periodName/, periodName)
)
  .then(handleErrors({ errorMessage: 'Fetching Currency Conversion Rates failed' }))
  .then(parseAsJson);

export const addCurrencyConversionRate = async currencyConversionRate => await fetch(
  Config.endpoints.INSERT_CURRENCY_CONVERSION_RATE,
  {
    method: 'PUT',

    body: JSON.stringify(currencyConversionRate),
  }
)
  .then(handleErrors({ errorMessage: 'Inserting Currency Conversion Rate failed' }));

export const updateCurrencyConversionRate = async currencyConversionRate => await fetch(
  Config.endpoints.UPDATE_CURRENCY_CONVERSION_RATE,
  {
    method: 'POST',
    body: JSON.stringify(currencyConversionRate),
  }
)
  .then(handleErrors({ errorMessage: 'Updating Currency Conversion Rate failed' }));

export const removeCurrencyConversionRate = async currencyConversionRate => await fetch(
  Config.endpoints.DELETE_CURRENCY_CONVERSION_RATE
    .replace(':periodName', currencyConversionRate.periodName)
    .replace(':fromCurrency', currencyConversionRate.fromCurrency)
    .replace(':toCurrency', currencyConversionRate.toCurrency),
  {
    method: 'DELETE',
  }
)
  .then(handleErrors({ errorMessage: 'Removing Currency Conversion Rate failed' }));

export const validateCurrencyConversionRates = async currencyConversionRates => await fetch(
  Config.endpoints.VALIDATE_CURRENCY_CONVERSION_RATES,
  {
    method: 'POST',
    body: JSON.stringify(currencyConversionRates),
  }
)
  .then(handleErrors({ errorMessage: 'Validating Currency Conversion Rates failed' }))
  .then(parseAsJson);

export const importCurrencyConversionRates = async currencyConversionRates => await fetch(
  Config.endpoints.IMPORT_CURRENCY_CONVERSION_RATES,
  {
    method: 'POST',
    body: JSON.stringify(currencyConversionRates),
  }
)
  .then(handleErrors({ errorMessage: 'Importing Currency Conversion Rates failed' }));

export const fetchCurrencyCodes = async periodName => await fetch(
  Config.endpoints.FETCH_CURRENCY_CODES_ENABLED
    .replace(/:periodName/, periodName)
)
  .then(handleErrors({ errorMessage: 'Fetching Currency Options failed' }))
  .then(parseAsJson);
